/* Sentinel Mastery Landingpage
   Wird von mehreren Sections eingebunden, laeuft daher mehrfach durch.
   Alles ist idempotent: Custom Elements werden nur einmal registriert,
   der Reveal-Observer nur einmal gestartet. */
(function () {
  'use strict';

  /* ---------- Video: kein Autoplay, Iframe erst beim Klick ---------- */
  if (!customElements.get('sentinel-video')) {
    customElements.define(
      'sentinel-video',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.sm-video__frame');
          this.button = this.querySelector('.sm-video__play');
          if (!this.frame || !this.button) return;

          if (!this.videoId) {
            this.button.setAttribute('aria-disabled', 'true');
          } else {
            const hint = this.querySelector('.sm-video__hint');
            if (hint) hint.hidden = true;
          }
          this.button.addEventListener('click', this.play.bind(this));
        }

        get videoId() {
          return (this.frame.getAttribute('data-video-id') || '').trim();
        }

        play() {
          const id = this.videoId;
          if (!id) return;
          const provider = (this.frame.getAttribute('data-video-provider') || 'youtube').toLowerCase();
          const src =
            provider === 'vimeo'
              ? 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1'
              : 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';

          const iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.title = this.getAttribute('data-title') || 'Video';
          iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          this.frame.innerHTML = '';
          this.frame.appendChild(iframe);
        }
      }
    );
  }

  /* ---------- FAQ-Akkordeon ---------- */
  if (!customElements.get('sentinel-faq')) {
    customElements.define(
      'sentinel-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.prototype.slice.call(this.querySelectorAll('.sm-faq'));
          this.items.forEach((item) => {
            const button = item.querySelector('.sm-faq__q');
            if (button) button.addEventListener('click', () => this.toggle(item));
          });
        }

        toggle(item) {
          const wasOpen = item.classList.contains('is-open');
          this.items.forEach((other) => {
            other.classList.remove('is-open');
            const answer = other.querySelector('.sm-faq__a');
            const button = other.querySelector('.sm-faq__q');
            if (answer) answer.style.maxHeight = null;
            if (button) button.setAttribute('aria-expanded', 'false');
          });
          if (wasOpen) return;
          item.classList.add('is-open');
          const answer = item.querySelector('.sm-faq__a');
          const button = item.querySelector('.sm-faq__q');
          if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
          if (button) button.setAttribute('aria-expanded', 'true');
        }
      }
    );
  }

  /* ---------- Gratis-Zugang: Quelle aus ?quelle= mitschicken ---------- */
  if (!customElements.get('sentinel-lead-source')) {
    customElements.define(
      'sentinel-lead-source',
      class extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('input');
          if (!input) return;
          const source = new URLSearchParams(window.location.search).get('quelle');
          if (source) input.value = source.slice(0, 60);
        }
      }
    );
  }

  /* ---------- Menue schliessen, wenn ein Anker auf dieser Seite geklickt wird ----------
     Das Hauptmenue besteht aus Ankern (#akademie, #faq, ...). Auf dem Handy bleibt
     Dawns Drawer nach dem Klick offen und der Body bleibt scroll-gesperrt, die Seite
     wirkt eingefroren. Dawns closeMenuDrawer() schliesst hier nicht zuverlaessig,
     deshalb setzen wir die Zustaende selbst zurueck. */
  if (!window.__sentinelDrawerClose) {
    window.__sentinelDrawerClose = true;

    const targetOnThisPage = function (link) {
      if (!link.hash || link.hash === '#') return null;
      if (link.origin !== window.location.origin) return null;
      if (link.pathname !== window.location.pathname) return null;
      try {
        return document.getElementById(decodeURIComponent(link.hash.slice(1)));
      } catch (error) {
        return null;
      }
    };

    const closeDrawer = function (drawer) {
      const details = drawer.querySelector('details.menu-drawer-container');
      if (!details) return;

      details.classList.remove('menu-opening');
      details.querySelectorAll('details').forEach(function (sub) {
        sub.removeAttribute('open');
        sub.classList.remove('menu-opening');
      });
      details.querySelectorAll('.submenu-open').forEach(function (sub) {
        sub.classList.remove('submenu-open');
      });

      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');

      document.body.classList.remove(
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop'
      );

      // Erst nach der Slide-Animation schliessen, damit es nicht springt.
      setTimeout(function () {
        details.removeAttribute('open');
      }, 250);
    };

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;

      const link = event.target.closest('a[href*="#"]');
      if (!link) return;

      const target = targetOnThisPage(link);
      if (!target) return;

      const drawer = link.closest('header-drawer');
      if (!drawer) return;

      // Waehrend der Drawer offen ist, ist der Body scroll-gesperrt und der
      // Sprung zum Anker verpufft. Also selbst schliessen und selbst scrollen.
      event.preventDefault();
      closeDrawer(drawer);

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Ueber lange Strecken ist Smooth-Scrolling quaelend langsam, dort springen.
      const far = Math.abs(target.getBoundingClientRect().top) > 2000;
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: reduced || far ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', link.hash);
        }
      });
    });
  }

  /* ---------- Produktgalerie ---------- */
  if (!customElements.get('sentinel-gallery')) {
    customElements.define(
      'sentinel-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.main = this.querySelector('.sm-gallery__main img');
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.sm-gallery__thumb'));
          if (!this.main || this.thumbs.length < 2) return;
          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.select(thumb));
          });
        }

        select(thumb) {
          const img = thumb.querySelector('img');
          if (!img) return;
          this.main.src = thumb.getAttribute('data-full') || img.src;
          this.main.srcset = thumb.getAttribute('data-srcset') || '';
          this.main.alt = img.alt || '';
          this.thumbs.forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
        }
      }
    );
  }

  /* ---------- Scroll-Reveal, genau einmal pro Seite ---------- */
  if (!window.__sentinelReveal) {
    window.__sentinelReveal = true;

    const start = function () {
      const items = Array.prototype.slice.call(document.querySelectorAll('.sm-reveal'));
      if (!items.length) return;

      const showAll = function () {
        items.forEach(function (el) {
          el.classList.add('is-in');
        });
      };

      // Im Theme-Editor nichts verstecken, sonst wirken Section-Previews leer.
      if (window.Shopify && window.Shopify.designMode) {
        showAll();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        showAll();
        return;
      }

      const revealVisible = function () {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        items.forEach(function (el) {
          if (el.getBoundingClientRect().top < vh * 0.95) el.classList.add('is-in');
        });
      };

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach(function (el) {
        observer.observe(el);
      });
      revealVisible();
      window.addEventListener('load', revealVisible);
      // Sicherheitsnetz: nie eine Section dauerhaft unsichtbar lassen.
      setTimeout(showAll, 3500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
